import React from 'react';
import {get} from 'lodash';
import className from 'classnames';

import {
  userTypes,
} from '../lib/helpers'

class DotTooltip extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
    user: {},
  };

  state = {
  };

  render = () => {
    const user = this.props.user

    return (
      <div
        className={className('DotTooltip', {
          'DotTooltip--whs-nw': true,
          [`DotTooltip--c-${user.type}`]: user.type,
        })}
      >
        <a className="DotTooltip__a">
          <div className='DotTooltip__a__panel'>
            <span className='DotTooltip__a__panel__span'>{get(userTypes, user.type)}</span>
          </div>
        </a>

        {user.type === 'deleted' ?
          <span className='DotTooltip__deleted'>{user.id}</span>
        :
          <a
            className='DotTooltip__link'
            href={`/${gon.currentProvider}/users/${user.id}`}
          >
            {user.id}
          </a>
        }
      </div>
    );
  }
}

export default DotTooltip;
